import moment from 'moment';
import React, { useCallback } from 'react';
import { generatePath, useRouteMatch } from 'react-router-dom';
import { DATE_FORMAT_URL, DATE_ISO_FORMAT } from '../../../../../data/constants/datetime';
import { useEvent } from '../../../../../data/hooks/eventHooks';
import { DateTabs } from '../../../../elements/Tabs';
import TopBarEvent from '../../../../elements/TopBar/TopBarEvent';
import { EVENT_SCHEDULE_TAB_SEARCH, EVENT_SCHEDULE_TAB_TAGGED } from '../../schedule-header-tabs';
import { useScheduleAndMeetings } from '../../useScheduleAndMeetings';
import ScheduleFilterSelection from './ScheduleFilterSelection';
import ScheduleTabs from './ScheduleTabs';
import ScheduleTextFilter from './ScheduleTextFilter';
import { useDatesFromItems } from '../../../../../data/hooks/datetime/useDatesFromItems';
import ToolbarLayout from '../../../../elements/ToolbarLayout';
import ToolbarButton from '../../../../elements/ToolbarButtons/ToolbarButton';
import SpeakersToolbarButton from '../../../../elements/ToolbarButtons/SpeakersToolbarButton/SpeakersToolbarButton';

function EventScheduleHeader(props) {
    const { eventId, returnURL = '../../..' } = props,
        event = useEvent(eventId),
        { path, params } = useRouteMatch(),
        { date, tab } = params,
        schedule = useScheduleAndMeetings(eventId),
        dates = useDatesFromItems(event, schedule).map((d) => d.format(DATE_ISO_FORMAT));

    const handleDateSelection = useCallback(
            (date) => {
                app.history.replace(generatePath(path, { ...params, date: moment(date).format(DATE_FORMAT_URL) }));
            },
            [path, params]
        ),
        handleTabSelection = useCallback(
            (tab) => {
                let nextPath = generatePath(path, { ...params, tab });

                if (tab == EVENT_SCHEDULE_TAB_TAGGED) {
                    nextPath += '/filter';
                }

                app.history.replace(nextPath);
            },
            [path, params]
        );

    // console.log('DBG event', event)

    return (
        <>
            <TopBarEvent event={event} schedule returnURL={returnURL} />
            <ScheduleTabs eventId={eventId} tab={tab} onChange={handleTabSelection} />
            <ToolbarLayout>
                <DateTabs dates={dates} value={moment(date, DATE_FORMAT_URL).format(DATE_ISO_FORMAT)} onChange={handleDateSelection} />
                <SpeakersToolbarButton eventId={eventId} />
            </ToolbarLayout>
            {tab == EVENT_SCHEDULE_TAB_TAGGED ? <ScheduleFilterSelection eventId={eventId} /> : null}
            {tab == EVENT_SCHEDULE_TAB_SEARCH ? <ScheduleTextFilter eventId={eventId} /> : null}
        </>
    );
}

export default EventScheduleHeader;
